/*
 * TotalData
 *
 * A component to create and calculate the total data in a page from total all data.
 * E.g: "1-50 dari 111 transaksi"
 */

import { useTranslation } from "react-i18next";

import { delimiter } from "src/helpers/number";

export type TotalDataProps = {
  /**
   * Set data that will be used for get total
   */
  data?: { data?: any; total_data?: number; data_per_page?: number };

  /**
   * Set current page
   */
  page?: number;

  /**
   * Set data limit for one page
   */
  limit?: number;

  /**
   * Set data type
   *
   * @type {"transaction" | "beneficiary" | "report" | "account" | "link" | "bill"}
   */
  type: "transaction" | "beneficiary" | "report" | "account" | "link" | "bill" | "country";

  /**
   * Show the "from N <type>" total-count part after the range
   *
   * @default {true}
   */
  withTotalCount?: boolean;
};

const defaultProps = {
  data: {},
  page: 1,
  limit: 50,
  type: "transaction",
  withTotalCount: true
};

function TotalData(props: TotalDataProps) {
  const { data, page, limit, type, withTotalCount } = props;
  const { t } = useTranslation("translation");

  const copyTotalCount = (
    <>
      {" "}
      {t("total-data.from")} {delimiter(data.total_data)} {t(`total-data.${type}`)}
    </>
  );

  return (
    <>
      {data.data && data.data?.length > 0 && (
        <div className="u-text-right">
          {t("displaying")} {(page - 1) * limit + 1}-{(page - 1) * limit + data.data_per_page}
          {withTotalCount ? copyTotalCount : " " + t(`total-data.${type}`)}
        </div>
      )}
    </>
  );
}

TotalData.defaultProps = defaultProps;

export default TotalData;
